function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.658 1.262h39.014c1.544 0 2.787 1.33 2.787 2.984v47.737c0 1.653-1.243 2.984-2.787 2.984H8.658c-1.544 0-2.787-1.33-2.787-2.983V4.245c0-1.652 1.243-2.983 2.787-2.983z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.613 4.69a1.143 1.143 0 112.286 0 1.143 1.143 0 01-2.286 0zM5.871 8.118h44.587M34.467 4.69a1.143 1.143 0 112.286 0 1.143 1.143 0 01-2.286 0zM39.04 4.69a1.143 1.143 0 112.286 0 1.143 1.143 0 01-2.286 0z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M43.028 28.114c0 8.204-6.654 14.855-14.862 14.855s-14.862-6.65-14.862-14.855 6.654-14.855 14.862-14.855 14.862 6.65 14.862 14.855z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.598 28.114c0 6.31-5.119 11.427-11.433 11.427s-11.433-5.116-11.433-11.427 5.119-11.427 11.433-11.427 11.433 5.116 11.433 11.427zM9.3 3.547h10.29v2.285H9.3z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.189 30.4s3.901-3.085 6.974-3.085c3.072 0 6.645 3.118 9.718 3.085 2.222-.024 5.716-3.428 5.716-3.428"
}));

var SvgWashingmachine = function SvgWashingmachine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWashingmachine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Washing machine.fb25da1d.svg";
export { ForwardRef as ReactComponent };